import { lazy } from 'react';
import { APP_PATHS } from '../paths';
import { RouteConfig } from '../types';

const LandingPage = lazy(() => import('../../views/auth/LandingPage'));
const EnterEmail = lazy(() => import('../../views/auth/EnterEmail'));
const EnterPassword = lazy(() => import('../../views/auth/EnterPassword'));
const CreateAccount = lazy(() => import('../../views/auth/CreateAccount'));
const EnterVerificationCode = lazy(
  () => import('../../views/auth/EnterVerificationCode')
);
const EnterForgotPasswordVerificationCode = lazy(
  () => import('../../views/auth/EnterForgotPasswordVerificationCode')
);
const CreateNewPassword = lazy(
  () => import('../../views/auth/CreateNewPassword')
);

export const authRoutes: RouteConfig[] = [
  {
    path: APP_PATHS.welcome,
    element: <LandingPage />,
  },
  {
    path: APP_PATHS.enterEmail,
    element: <EnterEmail />,
  },
  {
    path: APP_PATHS.nace,
    element: <EnterEmail />,
  },
  {
    path: APP_PATHS.enterPassword,
    element: <EnterPassword />,
  },
  {
    path: APP_PATHS.createAccount,
    element: <CreateAccount />,
  },
  {
    path: APP_PATHS.enterVerificationCode,
    element: <EnterVerificationCode />,
  },
  {
    path: APP_PATHS.enterForgotPasswordVerificationCode,
    element: <EnterForgotPasswordVerificationCode />,
  },
  {
    path: APP_PATHS.createNewPassword,
    element: <CreateNewPassword />,
  },
];
